import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  searchText: string;
  fileCount: number;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.subscribeToRouteParam();
  }

  private subscribeToRouteParam(): void {
    this.route.queryParamMap.subscribe(
      (params: ParamMap) => (this.searchText = params.get('search'))
    );
  }

  setFileCount(count) {
    this.fileCount = count;
  }
}
